import type { JSX } from 'react'
import { seasonColors } from './shared'

const christmasPaths = {
  roofSnow:
    'M117.6 119.5V114Q126 110.6 142 111.4Q172 109.6 204 111Q244 109.8 279.8 112.2V118.6' +
    'Q273 121.6 266 118.8Q257 123.2 248 118.8Q204 120.2 162 118.8Q152 123.4 143 118.8' +
    'Q131 121.6 117.6 119.5Z',
  cabSnow:
    'M279.5 133V128.8Q296 126.6 311 128.6Q319 129.4 323.5 133Q315 134.6 307 133.2' +
    'Q296 135.2 287 133.4Q283 134 279.5 133Z',
  treeTop: 'M136 86L150 90L162 82L176 89L190 83L204 90L218 86L232 92L246 90L258 95L272 98',
  treeBottom: 'L258 101L246 106L232 104L218 110L204 106L190 113L176 107L162 114L150 106L136 112Z',
}

export function ChristmasRoofLoad(): JSX.Element {
  const { snow, snowEdge, wood, pine, pineShade, red } = seasonColors
  const { roofSnow, cabSnow, treeTop, treeBottom } = christmasPaths
  return (
    <g>
      <g fill={snow} stroke={snowEdge} strokeWidth="1">
        <path d={roofSnow} />
        <path d={cabSnow} />
      </g>
      <rect x="124" y="95" width="13" height="6" rx="1.5" fill={wood} />
      <path fill={pine} d={treeTop + treeBottom} />
      <path fill={pineShade} d={`M136 99.5H272${treeBottom}`} />
      <g fill={snow}>
        <ellipse cx="170" cy="86.5" rx="4" ry="1.6" />
        <ellipse cx="211" cy="87.8" rx="3.4" ry="1.4" />
        <ellipse cx="243" cy="91.6" rx="3" ry="1.2" />
      </g>
      <g fill={red}>
        <rect x="167" y="85" width="4.2" height="31" />
        <rect x="225" y="88.4" width="4.2" height="27.6" />
        <path d="M169 85C163 78 157 81 161 86ZM169 85C175 78 181 81 177 86Z" />
      </g>
    </g>
  )
}
